import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import store, { RootState } from 'redux/store';
import { getElementPosition } from '../../../editor/core/highed.dom';
import { updateCustomizedAction, setAction } from '../../../pages/ChartEditorPage/actions/chartEditor';

type Position = {
  x: number;
  y: number;
};

export const hideInlineDeleteButton = () => {
  store.dispatch(
    setAction({
      inlineDeleteOptions: false
    })
  );
};

const RichtextGroupModal = () => {
  const { inlineDeleteOptions: options } = useSelector<any, any>((state: RootState) => state.chartEditorPage);
  const dispatch = useDispatch();

  const updateCustomizedProp = (
    optionProps: string | object,
    val: any,
    extraModulesToLoad?: any,
    index?: number,
    skipEmit?: boolean
  ) => {
    return dispatch(updateCustomizedAction({ optionProps, val, extraModulesToLoad, index, skipEmit }));
  };

  const [position, setPosition] = useState({
    display: 'none',
    left: '',
    top: ''
  });

  const hide = () =>
    setPosition({
      display: 'none',
      left: '',
      top: ''
    });

  useEffect(() => {
    if (options) {
      // Position correctly
      const box = options.box;
      const offsetY = 66; // TODO: remove magic numbers
      let offsetX = 0;

      const pos = getElementPosition(box, true) as Position,
        size = box.getBoundingClientRect();
      const navBar = document.querySelector('.navigation-container-vertical');

      if (navBar) {
        const navSize = navBar.getBoundingClientRect();
        offsetX = navSize.width;
      }

      setPosition({
        top: pos.y + size.height + 3 - offsetY + 'px',
        left: pos.x - offsetX + 'px',
        display: 'block'
      });
    } else hide();
  }, [options]);

  const deleteElement = () => {
    const disable = options?.popup?.disable?.option;
    if (disable) {
      updateCustomizedProp({ id: disable }, false);
      hide();
    }
  };

  return (
    <div
      className="z-[1000] absolute p-[6px] bg-[#f7f7f7] text-ev-navy-blue-2 cursor-pointer"
      onClick={deleteElement}
      style={position}
    >
      <i className="fa fa-trash" aria-hidden="true" />
    </div>
  );
};

export default RichtextGroupModal;
